/** Must match `body.mm-tour-export-locked` in `product-tour.css` */
export const TOUR_EXPORT_LOCK_CLASS = 'mm-tour-export-locked'
